"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepLabel = exports.StepCounter = exports.StepBarItem = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ = require("../../../..");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StepBarItem = exports.StepBarItem = _styledComponents["default"].li.withConfig({
  displayName: "StepProgressBarItemstyle__StepBarItem",
  componentId: "sc-g0yy9w-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;flex:1;height:100%;:not(:first-child)::before,:not(:last-child)::after{position:absolute;content:'';border-bottom:6px solid ", ";width:100%;top:15px;z-index:2;}::before{left:-50%;}::after{left:50%;}"], function (_ref) {
  var theme = _ref.theme,
    isHighlighted = _ref.isHighlighted;
  return isHighlighted ? theme.color.brandSecondary.light : theme.color.brandPrimary.light;
});
var StepLabel = exports.StepLabel = _styledComponents["default"].div.withConfig({
  displayName: "StepProgressBarItemstyle__StepLabel",
  componentId: "sc-g0yy9w-1"
})(function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    marginRight: spacing.inline['6xs'],
    marginLeft: spacing.inline['6xs']
  };
});
var StepCounter = exports.StepCounter = (0, _styledComponents["default"])(_.IconButton).withConfig({
  displayName: "StepProgressBarItemstyle__StepCounter",
  componentId: "sc-g0yy9w-2"
})({
  zIndex: 3,
  ':disabled': {
    pointerEvents: 'none',
    opacity: '1'
  }
});